// extracted by mini-css-extract-plugin
module.exports = {"featuredHeader":"featuredHeader_featuredHeader__2L40S","menu":"featuredHeader_menu__37PXh","list":"featuredHeader_list__36nqG","active":"featuredHeader_active__273LY"};